import {DynaTravelModule} from "./DynaTravelModule";
import {dynaTravelModuleConfig} from "../../../settings/dynaTravelModuleConfig";

export const dynaTravelModule = new DynaTravelModule(dynaTravelModuleConfig);